import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

export default function AdSenseModal({ onClose, autoCloseDelay = 15000 }) {
  const [secondsRemaining, setSecondsRemaining] = useState(Math.floor(autoCloseDelay / 1000));
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    // Initialize AdSense ad
    try {
      if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error('AdSense initialization error:', error);
    }

    // Countdown timer
    const countdown = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setCanClose(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Auto-close after delay
    const autoClose = setTimeout(() => {
      onClose();
    }, autoCloseDelay);

    return () => {
      clearInterval(countdown);
      clearTimeout(autoClose);
    };
  }, [autoCloseDelay, onClose]);

  const handleClose = () => {
    if (canClose) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bunker-panel max-w-4xl w-full p-6 relative">
        {/* Close button - only active after countdown */}
        <button
          onClick={handleClose}
          disabled={!canClose}
          className={`absolute top-4 right-4 transition-all ${
            canClose
              ? 'text-white hover:text-red-400 cursor-pointer'
              : 'text-gray-600 cursor-not-allowed opacity-50'
          }`}
          title={canClose ? 'Close' : `Wait ${secondsRemaining}s`}
        >
          <X className="w-6 h-6" />
        </button>

        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-amber mb-2 font-mono">
            ☢️ TACTICAL INTERMISSION ☢️
          </h2>
          <p className="text-muted text-sm font-mono">
            {canClose ? (
              'Click X to return to Command Center'
            ) : (
              `Auto-returning in ${secondsRemaining}s...`
            )}
          </p>
        </div>

        {/* AdSense Container */}
        <div className="bg-white rounded-lg p-4 min-h-[250px] flex items-center justify-center">
          {/* Google AdSense Ad Unit */}
          <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-8461941127569704"
            data-ad-slot="auto"
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>

        {/* Footer message */}
        <div className="text-center mt-4">
          <p className="text-xs text-muted font-mono">
            Want to skip ads? <button onClick={onClose} className="text-yellow-400 hover:text-yellow-300 underline">Upgrade to Premium</button>
          </p>
        </div>
      </div>
    </div>
  );
}
